import React, { useState, useEffect } from 'react';
import Layout from '../common/layoutred';
import Button from '../../assets/images/backgrounds/submit_button.png';
import './style.scss';
import { connect } from 'react-redux';
import { lang, saveUserDetails } from '../../store/trackinguser/actions';
import { Alert } from '@material-ui/lab';

window.gtag('event', 'LANGUAGE_SELECTION', {
  'event_category' : 'LANGUAGE_SELECTION',
  'event_label' : 'LANGUAGE_SELECTION'
});

const LanguageSelection = ({
  languages,
  saveInitialLanguage,
  saveUserDetails,
}) => {
  const [lang,setLang]=useState("en")

  const [error, setError] = useState(false);
  const [msg, setMsg] = useState('Please enter valid details');
  const [data, setData] = useState({
    number: '',
  })

  const handleChange=(event)=>{
  const { name, value } = event.target;
  if (name === 'lang') {
    setLang(value);
    return;
  }
  if (name === 'number') {
    const onlyDigits = String(value).replace(/\D/g, '');
    const trimmed = onlyDigits.slice(0, 10);
    setData({ ...data, number: trimmed });
    setError(false);
    return;
  }
  setData({ ...data, [name]: value });
  }

  const next=(e)=>{
  saveInitialLanguage(lang)
  saveUserDetails({ number: data.number })
  }

  const register = (event) => {
    event.preventDefault();
    if (data.number.length !== 10) {
      setError(true);
      setMsg('Please enter valid number');
      return;
    }
    if (data.number.length === 10) {
      next()
    }
  };

  
  return (
    <>
      <Layout>
        <div className="language__container">
          <form onSubmit={register}>
            <div className="form__control">
                <select name="lang" value={lang} onChange={handleChange}>
                {languages
                  ? languages.map((lan) => (
                      <option key={lan.value} value={lan.value}>
                        {lan.language}
                      </option>
                    ))
                  : null}
              </select>
            </div>

            <div className="form__control">
              <input
                type="number"
                placeholder="Enter Phone Number"
                name="number"
                value={data.number}
                onChange={handleChange}
              />
            </div>
            <div className="form__control next_button" type="submit" onClick={register} >
              <img src={Button} alt="next_image" />
              <div type="submit" className="button__text">
                Next
              </div>
            </div>
            <div className="form__control error__msg">
              {error ? (
                <Alert severity="error">
                  <h3>{msg}</h3>
                </Alert>
              ) : null}
            </div>
          </form>
        </div>
      </Layout>
    </>
  );
};

const mapState = (state)=>{
  return {
    languages: state.intialize.languages,
    lan: state.trackingUser.saveInitialLanguage,
    number: state.trackingUser.number,
  }
}

const mapDispathToProps = (dispatch) => {
  return {
      saveInitialLanguage:(language)=>dispatch(lang(language)),
      saveUserDetails:(details)=>dispatch(saveUserDetails(details))
  }
}

export default connect(mapState,mapDispathToProps) (LanguageSelection);